import { birthDateSchema } from 'shared/validators/date.validator';
import * as yup from 'yup';

/**
 * Буквы, из которых состоят имена.
 *
 * `Ёё` перечислены отдельно: в Unicode `Ё` (U+0401) стоит до `А` (U+0410), а `ё`
 * (U+0451) — после `я` (U+044F), поэтому в диапазоны `А-Я` и `а-я` они не входят.
 * Без них «Артём» не проходит проверку, а форматтер поля вырезает букву прямо
 * при вводе.
 */
const NAME_LETTERS = 'A-Za-zА-Яа-яЁё';

/**
 * Имя целиком: части из букв, между ними — дефис, апостроф или пробел.
 *
 * Разделители нужны для составных имён и фамилий: «Анна-Мария», «О'Коннор»,
 * «Ван дер Берг». Разделитель не может стоять с краю и не может идти подряд,
 * поэтому «Иван-» и «Иван--Пётр» отсекаются.
 */
export const NAME_REGEX = new RegExp(`^[${NAME_LETTERS}]+(?:[-' ][${NAME_LETTERS}]+)*$`);

const nameMessage = (subject: string) => `${subject} должно содержать только буквы, дефис или апостроф`;

export const applicationLinkValidator = yup.object().shape({
  name: yup.string().required('Имя обязательно').matches(NAME_REGEX, nameMessage('Имя')),
  surname: yup.string().required('Фамилия обязательна').matches(NAME_REGEX, nameMessage('Фамилия')),
  patronymic: yup
    .string()
    .optional()
    // excludeEmptyString обязателен: по умолчанию `matches` проверяет и пустую
    // строку, а Formik стартует именно с '', и форма с незаполненным отчеством
    // навсегда остаётся невалидной — при том что поле подписано «не обязательно».
    .matches(NAME_REGEX, { message: nameMessage('Отчество'), excludeEmptyString: true })
    .nullable(),
  birthday: birthDateSchema,
  number: yup
    .string()
    .required('Укажите игровой номер')
    .test('range', 'Номер должен быть от 1 до 99', (value) => {
      const parsed = Number(value);
      return Number.isInteger(parsed) && parsed >= 1 && parsed <= 99;
    }),
  position: yup
    .object()
    .shape({ value: yup.string().required(), label: yup.mixed().required() })
    .required('Укажите амплуа')
    .nullable(),
  photo: yup.array().optional(),
  consent: yup.boolean().oneOf([true], 'Без согласия на обработку данных заявку отправить нельзя'),
});
